import React from 'react';
import cx from 'classnames';
import Text, { TextSize } from '@move-ui/text';
import styles from './Label.module.css';
export const Label = ({ className, children, htmlFor, isScreenReaderOnly, applyDisabledStyle }) => (
// eslint-disable-next-line jsx-a11y/label-has-associated-control
React.createElement("label", { className: cx({ [styles.screenReaderOnly]: isScreenReaderOnly }, className), htmlFor: htmlFor },
    React.createElement(Text, { size: TextSize.XS, color: applyDisabledStyle ? 'neutral-300' : 'neutral-100', bold: true }, children)));
//# sourceMappingURL=Label.js.map